import { baseApi } from "./baseApi";

const SMS_TEMPLATE_BASE_URL = "/sms-templates";

export const smsTemplateApi = baseApi.injectEndpoints({
  tagTypes: ["SmsTemplate"],

  endpoints: (build) => ({
    addSmsTemplate: build.mutation({
      query: (body) => ({
        url: SMS_TEMPLATE_BASE_URL,
        method: "POST",
        body,
      }),
      invalidatesTags: [
        { type: "SmsTemplate", id: "LIST" },
        { type: "SmsTemplate", id: "DDL" },
      ],
    }),

    listSmsTemplates: build.query({
      query: (params) => ({
        url: SMS_TEMPLATE_BASE_URL,
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result.data.map(({ _id }) => ({
                type: "SmsTemplate",
                id: _id,
              })),
              { type: "SmsTemplate", id: "LIST" },
            ]
          : [{ type: "SmsTemplate", id: "LIST" }],
    }),

    getSmsTemplateDetail: build.query({
      query: (smsTemplateId) => `${SMS_TEMPLATE_BASE_URL}/${smsTemplateId}`,
      providesTags: (result, error, { _id }) => [
        { type: "SmsTemplate", id: _id },
        { type: "SmsTemplate", id: "LIST" },
      ],
    }),

    getDDLSmsTemplateList: build.query({
      query: (params) => ({
        url: `${SMS_TEMPLATE_BASE_URL}/ddl`,
        params,
      }),
      providesTags: (result) =>
        result
          ? [
              ...result.map(({ _id }) => ({ type: "SmsTemplate", id: _id })),
              { type: "SmsTemplate", id: "DDL" },
            ]
          : [{ type: "SmsTemplate", id: "DDL" }],
    }),

    updateSmsTemplate: build.mutation({
      query: ({ id, ...body }) => ({
        url: `${SMS_TEMPLATE_BASE_URL}/${id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: (result, error, { _id: id }) => [
        { type: "SmsTemplate", id },
        { type: "SmsTemplate", id: "LIST" },
      ],
    }),

   }),
  overrideExisting: false,
});

export const {
  useAddSmsTemplateMutation,
  useListSmsTemplatesQuery,
  useGetSmsTemplateDetailQuery,
  useGetDDLSmsTemplateListQuery,
  useLazyGetDDLSmsTemplateListQuery,
  useUpdateSmsTemplateMutation,
} = smsTemplateApi;